<mat-dialog-actions cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="title"  >
		{{ (formMode === 'Copy'? 'MODALS.HEADERS.COPY_BOARD' : 'MODALS.HEADERS.BOARD')| translate }}
		<app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="this.formState === 'Submitting'"></app-component-loading>
	</div>
	<mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<fieldset [disabled]="formState ==='Submitting'">
	<form [formGroup]="mngtBoardForm" class="board-form">
        <div *ngIf="formMode === 'Copy'" class="universal-info" >
            {{ 'MODALS.TEXT.COPY_BOARD' | translate }}
        </div>
        
        <mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important;">
            <mat-label>{{ 'MODALS.FIELDS.TITLE' | translate }}</mat-label>
            <input matInput [formControl]="name" autocomplete="disabled" >
            @if (name.hasError('required')) {
                <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
            }
        </mat-form-field>

        <div class="board-form-row">
            <mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 55% !important;">
                <mat-label>{{ 'MODALS.FIELDS.ALIAS' | translate }}</mat-label>
                <input matInput [formControl]="alias" autocomplete="disabled" >
                <mat-error *ngIf="alias?.hasError('required')">{{'VALIDATION.REQUIRED' | translate}}</mat-error>
                <mat-error *ngIf="alias?.hasError('aliasTaken')">{{'VALIDATION.ALIAS_TAKEN' | translate}}</mat-error>
            </mat-form-field>
            <div class="form-field-cs" >
                <app-icon-picker   [formControlData]="icon" ></app-icon-picker>
            </div>
        </div>

        <mat-checkbox *ngIf="formMode==='Create'"  formControlName="need_to_create_statuses" class="size-m board-form-checkbox"  disableRipple >
            {{'MODALS.FIELDS.BASE_STATUSES' | translate }}
        </mat-checkbox>
        <mat-select *ngIf="formMode==='Create'" 
                class="board-form-select body-l-regular text-extra select-rotate" 
                disableRipple panelClass="nd-select-board-group" 	
                [placeholder]="'MODALS.FIELDS.SELECT.GROUP' | translate " formControlName="group_id">
                <mat-option  class="body-l-regular text-extra board-form-select-option " [value]="null"> 
                    <div>{{ 'MODALS.FIELDS.SELECT.NULLGROUP' | translate }}</div> 
                </mat-option>
            @for (group of  this.boardGroups;  track group.id) {
                <mat-option  class="body-l-regular text-extra board-form-select-option " [value]="group.id"> <div>{{ group?.title }}</div> </mat-option>
            }
        </mat-select>
        

        <mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important; height: unset !important;">
            <mat-label>{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</mat-label>
            <textarea matInput [formControl]="description" autocomplete="disabled" rows="3" ></textarea>
        </mat-form-field>
        
        <div class="board-form-button-block">
            <button mat-dialog-close class="button-icon size-xl secondary-button"  [disabled]="this.formState === 'Submitting'">
                <mat-icon svgIcon="close-line"></mat-icon>
                {{ 'MODALS.BUTTONS.CANCEL'|translate }}
            </button>
            <button (click)="formMode === 'Copy'? copyBoard() : createBoard()"  data-action="copyBoard createBoard" 
                [disabled]="mngtBoardForm.valid !==true || this.formState === 'Submitting'"
                class="button-icon size-xl primary-button" >
                <mat-icon svgIcon="save-2-fill"></mat-icon>
                {{('MODALS.BUTTONS.SAVE'|translate) }}
            </button>
        </div>
	</form>
</fieldset>